import { createFileRoute, Outlet } from '@tanstack/react-router';
import { requireRole } from '../lib/auth-guard.js';

// Layout-Route für /admin/clients. Rendert NUR die Kind-Routen via <Outlet/>:
// die Liste liegt in admin.clients.index.tsx, das Detail in admin.clients.$id.tsx.
export const Route = createFileRoute('/admin/clients')({
  component: AdminClientsLayout,
  beforeLoad: async ({ context }) => {
    await requireRole(context.queryClient, ['ceo', 'internal_staff']);
  },
});

function AdminClientsLayout() {
  return <Outlet />;
}
